import type { ApiResponseInterface } from "@/ts/interfaces/ApiResponseInterface";
import { get, post } from "./httpClient";

export const getSectionContent = async <T>({
  section,
  termId,
  weekId,
  gradeId,
  lessonId,
  subjectSlug
}: {
  section: string;
  termId: number;
  weekId: number;
  gradeId: number;
  lessonId: number;
  subjectSlug: string;
}): Promise<T> => {
  return await get<T>(
    `/lesson/grade/${gradeId}/term/${termId}/subject/${subjectSlug}/week/${weekId}/lesson/${lessonId}/activity/${section}`
  );
};

export const startLesson = <T>({
  termId,
  weekId,
  gradeId,
  lessonId,
  subjectSlug
}: {
  termId: number;
  weekId: number;
  gradeId: number;
  lessonId: number;
  subjectSlug: string;
}): Promise<T> => {
  return post<T>(
    `/lesson/grade/${gradeId}/term/${termId}/subject/${subjectSlug}/week/${weekId}/lesson/${lessonId}/start`
  );
};

export const completeLesson = async <T>({
  termId,
  weekId,
  gradeId,
  lessonId,
  subjectSlug
}: {
  termId: number;
  weekId: number;
  gradeId: number;
  lessonId: number;
  subjectSlug: string;
}): Promise<T> => {
  return await post<T>(
    `/lesson/grade/${gradeId}/term/${termId}/subject/${subjectSlug}/week/${weekId}/lesson/${lessonId}/finish`
  );
};

export const requestAccessForExternalService = async (
  serviceId: number
): Promise<ApiResponseInterface<void>> => {
  return await post(`/user/provision-external-services/${serviceId}`);
};

export const lessonsApi = { getSectionContent, startLesson, completeLesson, requestAccessForExternalService };
